import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { SupportService } from '../../../services/support.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

@Component({
  selector: 'app-support-case-summary',
  templateUrl: './support-case-summary.component.html',
  styleUrls: ['./support-case-summary.component.scss']
})
export class SupportCaseSummaryComponent implements OnInit {

    constructor(private _router: Router,
        private authentication: AuthenticationService,
        private common: CommonService,
        private supportService: SupportService) { }
    casesSummary: any = {
        closed: 0,
        open: 0,
        onhold: 0,
        escalated: 0
    };
    ngOnInit(): void {
        this.getCaseStatistics();
    }
    getCaseStatistics() {
        this.supportService.getCaseStatistics(this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null) {
                        this.casesSummary.closed = res.data.closed;
                        this.casesSummary.open = res.data.open;
                        this.casesSummary.onhold = res.data.onhold;
                        this.casesSummary.escalated = res.data.escalated;
                    }
                }
                else {
                    console.error("Web/Support/Statistics/getCaseStatistics()", res);
                }
            },
            (err: any) => {
                console.error("Web/Support/Statistics/getCaseStatistics()", err);
            }
        );
    }
}
